import Glide from '@glidejs/glide';
import 'core-js/es/array';

export default class Slider {

    constructor() {

        const sliders = Array.from(document.querySelectorAll('.glide'));

        if (!sliders.length || !window.matchMedia("(min-width: 800px)").matches) return;

        let sliderObj = {};

        sliders.forEach((slider, i) => {

            const clickableElements = Array.from(slider.querySelectorAll("a"));
            clickableElements.forEach((ele) =>
                ele.addEventListener("click", (e) => e.stopPropagation())
            );

            slider.addEventListener("click", (e) => {
                const sliderItem = event.target.closest('.c-lb__item');

                if (sliderItem) {
                    const anchor = sliderItem.querySelector("a");

                    if (anchor) {
                        anchor.click();
                    }
                }
            });

            let settings = {
                type: 'carousel',
                perView: 3,
                focusAt: 0,
                gap: 60,
                keyboard: false,
                breakpoints: {
                    1000: {
                        gap: 20
                    },
                    800: {
                        perView: 2,
                        gap: 20,
                    }
                }
            };

            const slidesLength = slider.dataset.itemsPerSlide;
            const disable = slider.dataset.disable;

            if(!isNaN(slidesLength)) {
                settings.perView = Number(slidesLength);
                settings.focusAt = 0;
            }
            
            // Add glide to the object for reference, disable global keyboard
            sliderObj[i] = new Glide(slider, settings);

            // Attatch event listener and instruct slide to go left and right
            slider.addEventListener('keyup', (e) => {
                if (e.keyCode == 39) this.sliderObj[i].go('>');
                if (e.keyCode == 37) this.sliderObj[i].go('<');
            });

            const bulletCount = slider.querySelectorAll('.glide__slide').length;
            const bulletWrapper = slider.querySelector('.glide__bullets');

            for (let index = 0; index < bulletCount; index++) {
                const button = document.createElement('button');
                button.className = 'e-btn e-btn--bare glide__bullet';
                button.setAttribute("data-glide-dir", '=' + index);
                if (bulletWrapper) {
                    bulletWrapper.appendChild(button);
                }
            }

            // Mount
            var slide = sliderObj[i].mount();

            if (disable === "True" || disable === "true") {
                // slide.disable();
            }
        });

      window.addEventListener('resize', debounce(() => {
        sliders.forEach((slider, i) => {
          if (window.matchMedia("(min-width: 800px)").matches) {
            sliderObj[i].enable();
          }
          else {
            sliderObj[i].disable();
          }
        });
      }, 1000));

    }

}

function debounce(func, time) {
  time = time || 100; // 100 by default if no param
  var timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}